import { Modal } from 'components/Modal';
import styles from './ModalCancelOrder.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { useState } from 'react';
import { useCancelOrderByPlatformMutation } from 'redux/Api/ordersApi/ordersApi';
import { Loader } from '@mantine/core';

export const ModalCancelOrder = ({
  isShowCancelModal,
  setIsShowCancelModal,
  orderId,
  onCancel,
}: {
  isShowCancelModal: boolean;
  setIsShowCancelModal: (e: boolean) => void;
  orderId: string;
  onCancel?: () => Promise<void>;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [cancelOrderByPlatform] = useCancelOrderByPlatformMutation();
  const [error, setError] = useState<string | null>(null);

  const handleCancelOrder = async () => {
    setIsLoading(true);
    try {
      if (onCancel) {
        await onCancel();
        setIsShowCancelModal(false);
      } else {
        const response = await cancelOrderByPlatform({ orderId }).unwrap();
        console.log(response);
        setIsShowCancelModal(false);
      }
    } catch (error) {
      console.error('Error canceling order:', error);
      setError((error as { data: { message: string } }).data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={isShowCancelModal} setOpen={setIsShowCancelModal}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Уведомление' />
        <p className={styles.root_message}>Ты уверен, что хочешь отменить заказ?</p>
        <div className={styles.btnBlock}>
          <div className={styles.root_btn}>
            <Button
              onClick={handleCancelOrder}
              disabled={isLoading}
              className={styles.root_btn_exit}
              theme='danger'>
              {isLoading ? (
                <>
                  Отмена... <Loader size='xs' color='red' />
                </>
              ) : (
                'Отменить заказ'
              )}
            </Button>
            <Button
              onClick={() => setIsShowCancelModal(false)}
              className={styles.root_btn_cancel}
              theme='filed'>
              Отмена
            </Button>
          </div>
          {error && <p className={styles.error}>{error}</p>}
        </div>
      </div>
    </Modal>
  );
};
